import envDetect from '@tcc/env-detect';

export const getEnv = () => {
  return envDetect.getCurrentEnv() || 'local';
};
